import React from "react";

const AdminLanding = () => {


    return <div>
        <h2 style={{textAlign: "center", margin: "20px 0px"}}>Admin Dashboard</h2>
        <img 
    src="https://i0.wp.com/www.powder.com/wp-content/uploads/2017/01/POWP-161000-FALL-08.jpg?w=1920&ssl=1"
    />
    </div>
}


export default AdminLanding;